import { Spinner } from '@creditornot/cb-progress';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useIntl } from 'react-intl';

import { getInboundMerchant } from 'apis/merchant-onboarding-service/api';
import { useTelemetryViewEvent } from 'common/hooks';
import { ssmoBusinessOpeningTimesView } from 'core/telemetry/avo/Avo';

import StepPageWrapper from '../components/StepPageWrapper';
import { BASE_STEPS_PREVIEW_INTL_ID } from '../components/StepsPreview/constants';
import OpeningTimesForm from '../components/forms/OpeningTimesForm';
import { SsmoTask, SsmoStepsIdentifiers } from '../constants';

type OpeningTimesPageProps = {
  merchantId: string;
};

const OpeningTimesPage = ({ merchantId }: OpeningTimesPageProps) => {
  const { formatMessage } = useIntl();
  const { data: inboundMerchant, isFetching: isFetchingInboundMerchant } = useQuery(
    ['/merchant-admin/inbound-merchants', merchantId],
    () => getInboundMerchant(merchantId),
    {
      cacheTime: 0,
      staleTime: 0,
      refetchOnWindowFocus: false,
    },
  );

  useTelemetryViewEvent('ssmo_business_opening_times_view', {}, durationMs =>
    ssmoBusinessOpeningTimesView({ durationMs }),
  );

  if (isFetchingInboundMerchant || !inboundMerchant) {
    return (
      <StepPageWrapper
        title={formatMessage({ id: `${BASE_STEPS_PREVIEW_INTL_ID}.get-started.tasks.add-opening-times.title` })}
        step={SsmoStepsIdentifiers.OpeningHours}
        task={SsmoTask.OPENING_TIMES}
        disabled
      >
        <Spinner size="large" />
      </StepPageWrapper>
    );
  }

  return (
    <StepPageWrapper
      title={formatMessage({ id: `${BASE_STEPS_PREVIEW_INTL_ID}.get-started.tasks.add-opening-times.title` })}
      step={SsmoStepsIdentifiers.OpeningHours}
      task={SsmoTask.OPENING_TIMES}
    >
      <OpeningTimesForm inboundMerchant={inboundMerchant} />
    </StepPageWrapper>
  );
};

export default OpeningTimesPage;
